// import React, { useState, useEffect, useRef } from 'react';
// import { Container, Col } from 'react-bootstrap';

// import React, { useState, useEffect } from 'react';
// import { Container, Col } from 'react-bootstrap';
// import PropTypes from 'prop-types';
// import { IoMdCloseCircle } from 'react-icons/io';
// import { Button } from '@/shared/components/Button';
// import Loading from '@/shared/components/Loading';
// import AddAttachment from './AddAttachment';

// const ImageGrid = ({ Locationid }) => {
//   const [showAttachmentModal, setShowAtttachmentModal] = useState(false);
//   const toggleModalAttachment = () => setShowAtttachmentModal(!showAttachmentModal);
//   const [attchments, setAttachment] = useState([]);
//   const [isloading, setIsloadng] = useState(true);

//   const imgPath = 'https://navrang.mvd-tech.io/API/images/restaurant/attachment/';
//   const dummyImage = 'https://via.placeholder.com/164?text=No+Attachment';

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const url = await fetch(`https://navrang.mvd-tech.io/API/restaurant_location_data.php?id=${Locationid}`);
//         const response = await url.json();
//         if (response.status && response.message === 'Success') {
//           const parsedAttachment = JSON.parse(response.data[0].attachment);
//           setAttachment(parsedAttachment);
//           setIsloadng(false);
//         }
//       } catch (error) {
//         setIsloadng(false);
//       }
//     };

//     fetchData();
//   }, [Locationid]);

//   // Improved CSS styles for better grid layout
//   const styles = {
//     gridContainer: {
//       maxHeight: '400px',
//       overflowY: 'auto',
//       padding: '16px',
//     },
//     imageGrid: {
//       display: 'grid',
//       gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))',
//       gap: '16px',
//       padding: '8px',
//     },
//     imageWrapper: {
//       width: '100%',
//       aspectRatio: '1',
//       position: 'relative',
//       overflow: 'hidden',
//       borderRadius: '20px',
//       boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
//     },
//     image: {
//       width: '100%',
//       height: '100%',
//       objectFit: 'cover',
//       transition: 'transform 0.2s ease',
//     },
//     noImageContainer: {
//       display: 'flex',
//       justifyContent: 'center',
//       alignItems: 'center',
//       padding: '16px',
//     },
//     addButton: {
//       marginTop: '16px',
//     },
//   };

//   if (isloading) {
//     return <Loading />;
//   }

//   return (
//     <Container>
//       <div style={styles.gridContainer}>
//         {attchments.length === 0 ? (
//           <div style={styles.noImageContainer}>
//             <img src={dummyImage} alt="No Attachment" style={styles.image} />
//           </div>
//         ) : (
//           <div style={styles.imageGrid}>
//             {attchments.map(image => (
//               <div key={image.logo_id} style={styles.imageWrapper}>
//                 <img
//                   src={`${imgPath}${image.file_name}?w=200&h=200&fit=cover&auto=format`}
//                   srcSet={`${imgPath}${image.file_name}?w=200&h=200&fit=cover&auto=format&dpr=2 2x`}
//                   alt={image.file_name}
//                   loading="lazy"
//                   style={styles.image}
//                 />
//               </div>
//             ))}
//           </div>
//         )}
//       </div>
      
//       <Button 
//         variant="outline-primary" 
//         size="sm" 
//         title="Details" 
//         onClick={toggleModalAttachment}
//         style={styles.addButton}
//       >
//         <span className="lnr lnr-upload mx-2" /> Add Attachment
//       </Button>

//       {showAttachmentModal && (
//         <div className="modal fade show" style={{ display: 'block' }} tabIndex="-1">
//           <div className="modal-dialog modal-xl">
//             <div className="modal-content">
//               <div className="modal-header">
//                 <h3 className="modal-title">Add Attachment</h3>
//                 <Button 
//                   type="button" 
//                   variant="primary" 
//                   rounded 
//                   size="sm" 
//                   onClick={toggleModalAttachment} 
//                   aria-label="Close"
//                 >
//                   <IoMdCloseCircle className="close-icon" />
//                 </Button>
//               </div>
//               <div className="modal-body">
//                 <AddAttachment Locationid={Locationid} />
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//     </Container>
//   );
// };

// ImageGrid.propTypes = {
//   Locationid: PropTypes.string.isRequired,
// };

// export default ImageGrid;

import React, {
 useState, useEffect, useRef, useContext, 
} from 'react';
import { Container, Modal } from 'react-bootstrap';
import PropTypes from 'prop-types';
import { IoMdCloseCircle } from 'react-icons/io';
import { Button } from '@/shared/components/Button';
import Loading from '@/shared/components/Loading';
import AddAttachment from './AddAttachment';
import { GlobalVarContext } from '../../../../context/GlobalVarContext';

const ImageGrid = ({ Locationid }) => {
  const [showAttachmentModal, setShowAttachmentModal] = useState(false);
  const toggleModalAttachment = () => setShowAttachmentModal(!showAttachmentModal);
  const [attachments, setAttachments] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const { apiGlobal } = useContext(GlobalVarContext);
  
  const imgPath = `${apiGlobal}images/restaurant/attachment/`;
  const dummyImage = 'https://via.placeholder.com/164?text=No+Attachment';
  
  const gridContainerRef = useRef(null);

  const gridRef = useRef(null);

  useEffect(() => {
    const fetchData = async () => {
      const formData = new FormData();
      formData.append('id', Locationid);
      try {
        const url = await fetch(`${apiGlobal}restaurant_location_data.php`, {
          method: 'POST',
          body: formData,
        });
        const response = await url.json();
        if (response?.status && response?.message === 'Success') {
          const parsedAttachment = JSON.parse(response.data[0].attachment);
          setAttachments(parsedAttachment);
        }
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [Locationid]);

  useEffect(() => {
    // Auto-scroll to the bottom when attachments update
    if (gridContainerRef.current) {
      gridContainerRef.current.scrollTop = gridContainerRef.current.scrollHeight;
    }
  }, [attachments]);

  const styles = {
    gridContainer: {
      maxHeight: '400px',
      overflowY: 'auto',
      padding: '16px',
      border: '1px solid #ddd',
      borderRadius: '8px',
    },
    imageGrid: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))',
      gap: '16px',
      padding: '8px',
    },
    imageWrapper: {
      width: '100%',
      aspectRatio: '1',
      position: 'relative',
      overflow: 'hidden',
      borderRadius: '12px',
      boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
    },
    image: {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      transition: 'transform 0.2s ease-in-out',
    },
    noImageContainer: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      padding: '16px',
    },
    addButton: {
      marginTop: '16px',
    },
    modalOverlay: {
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    modalContent: {
      backgroundColor: '#fff',
      padding: '20px',
      borderRadius: '10px',
      width: '80%',
      maxWidth: '600px',
    },
  };

  if (isLoading) {
    return <Loading />;
  }

  return (
    <Container>
      <div style={styles.gridContainer} ref={gridContainerRef}>
        {attachments.length === 0 ? (
          <div style={styles.noImageContainer}>
            <img src={dummyImage} alt="No Attachment" style={styles.image} />
          </div>
        ) : (
          <div style={styles.imageGrid}>
            {attachments.map(image => (
              <div key={image.logo_id} style={styles.imageWrapper}>
                <img
                  src={`${imgPath}${image.file_name}?w=200&h=200&fit=cover&auto=format`}
                  srcSet={`${imgPath}${image.file_name}?w=200&h=200&fit=cover&auto=format&dpr=2 2x`}
                  alt={image.file_name}
                  loading="lazy"
                  style={styles.image}
                />
              </div>
            ))}
          </div>
        )}
      </div>

      <Button
        variant="outline-primary"
        size="sm"
        title="Add Attachment"
        onClick={toggleModalAttachment}
        style={styles.addButton}
      >
        <span className="lnr lnr-upload mx-2" /> Add Attachment
      </Button>
 
      <Modal
        show={showAttachmentModal}
        onHide={() => setShowAttachmentModal(false)}
        centered
        size="xl"
      >
        <Modal.Header closeButton>
          <Modal.Title>Add Attachment</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <AddAttachment Locationid={Locationid} />
        </Modal.Body>
      </Modal>

      {/* {showAttachmentModal && (
        <div style={styles.modalOverlay}>
          <div style={styles.modalContent}>
            <div className="modal-header">
              <h3 className="modal-title">Add Attachment</h3>
              <Button
                type="button"
                variant="primary"
                rounded
                size="sm"
                onClick={toggleModalAttachment}
                aria-label="Close"
              >
                <IoMdCloseCircle className="close-icon" />
              </Button>
            </div>
            <div className="modal-body">
              <AddAttachment Locationid={Locationid} />
            </div>
          </div>
        </div>
      )} */}
    </Container>
  );
};

ImageGrid.propTypes = {
  Locationid: PropTypes.string.isRequired,
};

export default ImageGrid;



// import React, { useState, useEffect, useRef } from 'react';
// import PropTypes from 'prop-types';
// import { Container, Col, Button } from 'react-bootstrap';
// import { IoMdCloseCircle } from 'react-icons/io';
// import Loading from '@/shared/components/Loading';
// import AddAttachment from './AddAttachment';

// const ImageGrid = ({ Locationid }) => {
//   const [showAttachmentModal, setShowAtttachmentModal] = useState(false);
//   const toggleModalAttachment = () => setShowAtttachmentModal(!showAttachmentModal);
//   const [attchments, setAttachment] = useState([]);
//   const [isloading, setIsloadng] = useState(true);

//   const imgPath = 'https://navrang.mvd-tech.io/API/images/restaurant/attachment/';
//   const dummyImage = 'https://via.placeholder.com/164?text=No+Attachment';

//   const gridRef = useRef(null);

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const url = await fetch(`https://navrang.mvd-tech.io/API/restaurant_location_data.php?id=${Locationid}`);
//         const response = await url.json();
//         if (response.status && response.message === 'Success') {
//           const parsedAttachment = JSON.parse(response.data[0].attachment);
//           setAttachment(parsedAttachment);
//           setIsloadng(false);
//         }
//       } catch (error) {
//         setIsloadng(false);
//       }
//     };

//     fetchData();
//   }, [Locationid]);

//   // Scroll handler for automatic vertical scrolling every 2 seconds
//   useEffect(() => {
//     const interval = setInterval(() => {
//       if (gridRef.current) {
//         gridRef.current.scrollBy({ top: 100, behavior: 'smooth' }); // Scroll down 100px every 2 seconds
//       }
//     }, 2000); // 2000ms = 2 seconds

//     // Cleanup interval when the component unmounts
//     return () => clearInterval(interval);
//   }, []);

//   const styles = {
//     gridContainer: {
//       maxHeight: '400px',
//       overflowY: 'auto', // This makes it scrollable
//       padding: '16px',
//       position: 'relative',
//     },
//     imageGrid: {
//       display: 'flex',
//       flexDirection: 'column',
//       gap: '16px',
//     },
//     imageWrapper: {
//       width: '100%',
//       aspectRatio: '1',
//       position: 'relative',
//       overflow: 'hidden',
//       borderRadius: '20px',
//       boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
//     },
//     image: {
//       width: '100%',
//       height: '100%',
//       objectFit: 'cover',
//       transition: 'transform 0.2s ease',
//     },
//     noImageContainer: {
//       display: 'flex',
//       justifyContent: 'center',
//       alignItems: 'center',
//       padding: '16px',
//     },
//     addButton: {
//       marginTop: '16px',
//     },
//   };

//   if (isloading) {
//     return <Loading />;
//   }

//   return (
//     <Container>
//       <div style={styles.gridContainer} ref={gridRef}>
//         {attchments.length === 0 ? (
//           <div style={styles.noImageContainer}>
//             <img src={dummyImage} alt="No Attachment" style={styles.image} />
//           </div>
//         ) : (
//           <div style={styles.imageGrid}>
//             {attchments.map(image => (
//               <div key={image.logo_id} style={styles.imageWrapper}>
//                 <img
//                   src={`${imgPath}${image.file_name}?w=200&h=200&fit=cover&auto=format`}
//                   srcSet={`${imgPath}${image.file_name}?w=200&h=200&fit=cover&auto=format&dpr=2 2x`}
//                   alt={image.file_name}
//                   loading="lazy"
//                   style={styles.image}
//                 />
//               </div>
//             ))}
//           </div>
//         )}
//       </div>

//       <Button 
//         variant="outline-primary" 
//         size="sm" 
//         title="Details" 
//         onClick={toggleModalAttachment}
//         style={styles.addButton}
//       >
//         <span className="lnr lnr-upload mx-2" /> Add Attachment
//       </Button>

//       {showAttachmentModal && (
//         <div className="modal fade show" style={{ display: 'block' }} tabIndex="-1">
//           <div className="modal-dialog modal-xl">
//             <div className="modal-content">
//               <div className="modal-header">
//                 <h3 className="modal-title">Add Attachment</h3>
//                 <Button 
//                   type="button" 
//                   variant="primary" 
//                   rounded 
//                   size="sm" 
//                   onClick={toggleModalAttachment} 
//                   aria-label="Close"
//                 >
//                   <IoMdCloseCircle className="close-icon" />
//                 </Button>
//               </div>
//               <div className="modal-body">
//                 <AddAttachment Locationid={Locationid} />
//               </div>
//             </div>
//           </div>
//         </div>
//       )}
//     </Container>
//   );
// };

// ImageGrid.propTypes = {
//   Locationid: PropTypes.string.isRequired,
// };

// export default ImageGrid;

